import Endpoints from 'constants/Endpoints';
import {RestRequestGET, RestRequestPOST} from 'libs/RestRequest';
import applySearchParams from "../libs/applySearchParams";
import applySortParams from "../libs/applySortParams";
import {setResource} from "../redux/actions";
import reduxStore from 'redux/store'
import isResponseValid from "../libs/isResponseValid";

const __get = async (url, resourcesName) => {
    try {
        let res = await RestRequestGET(url)
        if (resourcesName) {
            reduxStore.dispatch(setResource(resourcesName, res))
        }
        return res;
    } catch (error) {
    }
}

const __save = async (url, values) => {
    try {
        const resp = await RestRequestPOST(url, values)
        isResponseValid(resp, (e) => {
            throw new Error(e);
        })
        return resp;
    } catch (e) {
        console.error(e)
    }
}

const getRegistrationsList = async (searchData) => {
    const {pagination, search, sort} = searchData;

    let params = {
        ...pagination
    }
    params = applySearchParams(search, params);
    params = applySortParams(sort, params);
    return await RestRequestGET(Endpoints.ADMIN_USER_REGISTRATION_LIST, {params});
};

const acceptRegistration = async (regId, values) => {
    return await __save(Endpoints.ADMIN_USER_REGISTRATION_ID_ACCEPT(regId), values)
}

const rejectRegistration = async (regId, values) => {
    return await __save(Endpoints.ADMIN_USER_REGISTRATION_ID_REJECT(regId), values)
}

const getRegistration = async (regId) => {
    return await __get(Endpoints.ADMIN_USER_REGISTRATION_ID(regId))
};


const getAvailableOrgs = async () => {
    return await __get(Endpoints.ADMIN_USER_REGISTRATION_AVAILABLE_ORGS)
}

const getRegistrationOrganization = async (regId) => {
    return await __get(Endpoints.ADMIN_USER_REGISTRATION_ID_ORGANIZATION(regId))
};

const saveRegistrationOrganization = async (regId, values) => {
    return await RestRequestPOST(Endpoints.ADMIN_USER_REGISTRATION_ID_ORGANIZATION(regId), values)
};

export default {
    getRegistrationsList,
    getRegistration,
    getAvailableOrgs,
    acceptRegistration,
    rejectRegistration,
    getRegistrationOrganization,
    saveRegistrationOrganization
}